<template>
  <el-container>
    <el-header height="60px">
      <el-row type="flex" align="middle">
        <el-col>
          <div class="bar"></div>
          <div v-if="$route.params.title || $route.query.title">
            {{$route.params.title || decodeURIComponent($route.query.title)}}
          </div>
          <template v-else>
            <div v-for="(str, index) in title" :key="index">
              <i v-show="index" class="el-icon el-icon-arrow-right"></i>
              {{str}}
            </div>
          </template>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <slot></slot>
    </el-main>
    <el-footer v-if="footer">
      <slot name="footer"></slot>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: 'MainHeaderMainFooter',

  props: {
    footer: {
      type: Object,
      required: false,
      default: null
    },

    actionName: {
      type: String,
      required: false,
      default: ''
    }
  },

  computed: {
    title () {
      const title = []
      if (this.$route.hasOwnProperty('meta') && this.$route.meta.title) {
        Array.isArray(this.$route.meta.title) ? title.push(...this.$route.meta.title) : title.push(this.$route.meta.title)
      }
      return title
    }
  }
}
</script>

<style lang="scss" scoped>
.el-container {
  background-color: #f2f7ff;
}

.el-header {
  .el-col {
    display: flex;
    flex-direction: row;
    align-items: center;
    user-select: none;
    font-size: 16px;
    margin: 20px;

    .bar {
      width: 2px;
      height: .9em;
      margin: 0 10px 0 10px;
      background-color: #3f73d9;
    }

    .el-icon {
      margin: 0 8px;
    }
  }
}

.el-main {
  margin: 5px 5px 5px 10px;
}
</style>

